import { useMemo } from 'react';

import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useFetchBundlePaymentPlansQuery } from 'domains/account/actions/bundles/fetchBundlePaymentPlans';
import { useMyBundlesStatus } from 'modules/billing/hooks/useMyBundlesStatus';

export const useIsFreemiumAllowanceActivating = () => {
  const { isLoggedIn } = useAuth();
  const { isFreemium } = useAccountStatus();

  const { data: bundlePaymentPlans } = useFetchBundlePaymentPlansQuery(
    undefined,
    { skip: !isLoggedIn },
  );

  const freemiumAllowanceBundle = useMemo(
    () =>
      bundlePaymentPlans?.find(
        plan => plan.bundle.type === 'FREE_ALLOWANCE_FREEMIUM',
      ),
    [bundlePaymentPlans],
  );
  const bundlePaymentPlansLoaded = bundlePaymentPlans !== undefined;

  const { data: myBundlesStatus } = useMyBundlesStatus();

  const myBundlesStatusLoaded = myBundlesStatus !== undefined;

  const freemiumAllowanceBundleStatus = useMemo(
    () =>
      myBundlesStatus?.find(
        status => status.bundleId === freemiumAllowanceBundle?.bundle.bundle_id,
      ),
    [freemiumAllowanceBundle, myBundlesStatus],
  );

  const isActivating =
    isFreemium &&
    bundlePaymentPlansLoaded &&
    myBundlesStatusLoaded &&
    !freemiumAllowanceBundleStatus;

  return isActivating;
};
